import React, { Fragment } from 'react';
import AcceptedCookiesCard from '../analytics-cards/accepted-cookies-card/AcceptedCookiesCard';
import ActiveVisitorsCard from '../analytics-cards/active-visitors-card/ActiveVisitorsCard';
import RefusedCookiesCard from '../analytics-cards/refused-cookies-card/RefusedCookiesCard';
import AverageTimeCard from '../analytics-cards/average-time-card/AverageTimeCard';

function AnalyticsTrafficData() {
    return (
        <Fragment>
            <ActiveVisitorsCard></ActiveVisitorsCard>
            <AcceptedCookiesCard></AcceptedCookiesCard>
            <RefusedCookiesCard></RefusedCookiesCard>
            <AverageTimeCard></AverageTimeCard>
        </Fragment>
    );
}

export default AnalyticsTrafficData;
